import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async createUserProfile({ commit }, data) {
      try {
        return await api.post('/users/profiles', data)
      } catch (error) {
        throw error
      }
    },

    async deleteUserProfile({ commit }, userProfileId) {
      try {
        return await api.delete(`/users/profiles/${userProfileId}`)
      } catch (error) {
        throw error
      }
    },

    async createUserProfileCodCCusto({ commit }, data) {
      try {
        return await api.post(
          `/users/profiles/${data.userProfileId}/codCCCusto`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    async deleteUserProfileCodCCusto({ commit }, data) {
      try {
        return await api.delete(
          `/users/profiles/${data.userProfileId}/codCCCusto/${data.userProfileCodCCustoId}`,
        )
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
